import { OrderEnumsOrderFilterTypeEnum } from '@genial/services/dist/models';
import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';
import { OrderByModalTypes } from '../../components/OrderByModal';

import {
  dateFilterFilter,
  estimatedValueFilter,
  orderSideFilter,
  orderStatusFilter,
  productFilter,
  sendDateFilter,
} from './filters';

export interface OrderHistoryDateFilterOption {
  label: string;
  value: OrderEnumsOrderFilterTypeEnum;
}

export const orderHistoryDateFilterOptions: OrderHistoryDateFilterOption[] = [
  { label: 'Últimos 30 dias', value: 'Last30Days' },
  { label: 'Últimos 60 dias', value: 'Last60Days' },
  { label: 'Últimos 90 dias', value: 'Last90Days' },
  { label: 'Últimos 12 meses', value: 'Last360Days' },
];

export interface OrderHistoryDateFilterStateProps {
  options: OrderHistoryDateFilterOption[];
  optionSelected: OrderHistoryDateFilterOption;
}

export const orderHistoryDateFilterState = atom<OrderHistoryDateFilterStateProps>({
  key: 'orderHistoryDateFilterState',
  default: {
    options: orderHistoryDateFilterOptions,
    optionSelected: orderHistoryDateFilterOptions[0],
  },
});

export const orderHistoryFiltersAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'orderHistoryFiltersAtom',
  default: {
    availableFilters: [
      dateFilterFilter,
      orderSideFilter,
      sendDateFilter,
      productFilter,
      orderStatusFilter,
      estimatedValueFilter,
    ],
    selectedFilters: [],
    appliedFilters: [],
  },
});

export const orderHistoryByAtom = atom<OrderByModalTypes.OrderByAtom>({
  key: 'orderHistoryByAtom',
  default: {
    availableOrderBy: [],
    selectedOrderBy: undefined,
    appliedOrderBy: undefined,
  },
});
